'use client'

import { Skeleton } from '@/components/skeleton'
import { RestaurantCardSkeleton } from '@/features/restaurants/restaurant-card/restaurant-card-skeleton'
import { RestaurantCardsProvider } from '@/features/restaurants/restaurant-card/restaurant-cards-context'
import { SEARCH_RESULTS_CLASS_NAME } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-results'
import { range } from '@/utils/functions/range'

interface IBrandPageSkeletonProps {
    /** The hub lists brand rows, a brand page shows a restaurant card grid */
    content: 'brands' | 'restaurants'
}

/** Mirrors the brands hub and brand pages: header block plus their list */
export const BrandPageSkeleton = ({ content }: IBrandPageSkeletonProps) => {
    return (
        <div className="flex w-full flex-col pt-4 md:pt-0 pb-14">
            {/* Breadcrumbs, headline, description */}
            <Skeleton className="h-5 w-56 max-w-full mb-2 md:mb-3" />
            <Skeleton className="h-9 md:h-11 w-72 md:w-[420px] max-w-full" />
            <Skeleton className="h-5 w-80 max-w-full mt-2 md:mt-3" />

            <div className="mt-6 md:mt-8" />

            {content === 'brands' ? (
                <div className="flex flex-col gap-y-4">
                    {range(6).map((_, index) => (
                        <Skeleton
                            key={'brand-skeleton-row' + index}
                            className="h-20 w-full rounded-l"
                        />
                    ))}
                </div>
            ) : (
                <div className={SEARCH_RESULTS_CLASS_NAME}>
                    <RestaurantCardsProvider styleType="default">
                        {range(6).map((_, index) => (
                            <RestaurantCardSkeleton key={'brand-skeleton-card' + index} />
                        ))}
                    </RestaurantCardsProvider>
                </div>
            )}
        </div>
    )
}
